const transformUTCToLocale = (timestring: string) => {
  const userTimezone = new Date().getTimezoneOffset() * 60 * 1000
  const UTCTime = Date.parse(timestring)
  const localeTime = new Date(UTCTime - userTimezone)

  return localeTime
}
export default transformUTCToLocale
